module.exports = __webpack_public_path__ + "img/Header-Background-bottom_.42096ad5.png";